export const ellipsisString = (str: string, maxLength = 23) => {
    const name = str.length > maxLength ? str.slice(0, maxLength - 3) + '...' : str;
    return name.replace('&nbsp;', '');
};